import React, { useState, useEffect, useCallback } from 'react'
import { generatePath, useHistory } from 'react-router-dom'
import {
  requestCustomerCreate,
} from 'requests/customers'
import useSearchCustomers from 'hooks/useSearchCustomers'
import useSearchParams from 'hooks/useSearchParams'
import { CUSTOMERS_SUBMENU } from 'constants/menu/submenus'
import { CUSTOMER_INFO } from 'constants/app-paths'
import { SIMPLE_CUSTOMER } from 'constants/objects/customer'
import { SideMenu } from 'components/SideMenu'
import { Form } from 'components/Customer/Form'
import { ListSkeleton } from 'components/ListSkeleton'
import { ListPage } from 'templates/ListPage'
import { Customer } from './components/Customer'
import { SearchForm } from './components/SearchForm'

export default function CustomersList() {
  const [responseError, setResponseError] = useState()
  const [showForm, setShowForm] = useState(false)
  const [saving, setSaving] = useState(false)
  const [filters, setFilters] = useState()
  const [search, searchCustomers] = useSearchCustomers()
  const [searchParams, setSearchParams] = useSearchParams()

  const history = useHistory()

  const getCustomers = useCallback((page, params) => {
    searchCustomers({ page, filters: params })
  }, [searchCustomers])

  useEffect(() => {
    const { filters: searchFilters, page, finished } = searchParams
    if (!finished) return

    setFilters(searchFilters)
    getCustomers(page, searchFilters)
  }, [getCustomers, searchParams])

  const onSelectCustomer = (id) => {
    const path = generatePath(CUSTOMER_INFO, { id })
    history.push(path)
  }

  const onSave = async (params) => {
    setSaving(true)
    const response = await requestCustomerCreate(params)

    setSaving(false)
    if (response.error) return setResponseError(response)

    return onSelectCustomer(response.data.id)
  }

  const onClickPagination = (page) => {
    setSearchParams({ ...filters, page })
    getCustomers(page, filters)
  }

  const onToggleForm = (show = false) => {
    setShowForm(show)
  }

  const onChangeFilters = (name, value) => {
    const changeFilters = { ...filters }
    if (!value) {
      delete changeFilters[name]
    } else {
      changeFilters[name] = value
    }

    setFilters(changeFilters)
  }

  const onSortList = (sortFilters) => {
    const newFilters = { ...filters, ...sortFilters }
    setFilters(newFilters)
    setSearchParams(newFilters)

    getCustomers(search.currentPage, newFilters)
  }

  const onSearch = () => {
    setSearchParams(filters)
    getCustomers(1, filters)
  }

  const renderForm = () => (
    <Form
      customer={SIMPLE_CUSTOMER}
      responseError={responseError}
      onSave={onSave}
      onCancel={() => setShowForm(false)}
      saving={saving}
    />
  )

  const renderSearchForm = () => (
    <SearchForm
      filters={filters}
      onChange={onChangeFilters}
      onSearch={onSearch}
      onSort={onSortList}
    />
  )

  const renderMenu = () => (
    <SideMenu submenu={CUSTOMERS_SUBMENU} />
  )

  const renderLoading = () => (
    <ListSkeleton />
  )

  const renderCustomer = (customer) => (
    <Customer
      key={`customer-list-${customer.id}`}
      customer={customer}
      onClick={onSelectCustomer}
    />
  )

  const renderList = () => {
    if (search.loading) return renderLoading()

    return search.customers.map(renderCustomer)
  }

  return (
    <ListPage
      renderForm={renderForm}
      renderMenu={renderMenu}
      listTitle="Lista de clientes"
      onClickPagination={onClickPagination}
      pagination={search.pagination}
      loading={search.loading}
      showForm={showForm}
      onToggleForm={onToggleForm}
      showAddButton
      renderSearchForm={renderSearchForm}
      openSearchForm
    >
      { renderList() }
    </ListPage>
  )
}
